import { render, staticRenderFns } from "./UserBenefitProcess.vue?vue&type=template&id=95367206"
import script from "./UserBenefitProcess.vue?vue&type=script&lang=js"
export * from "./UserBenefitProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports